import React from 'react'
import 'rc-slider/assets/index.css'
import '../styles/sliders.scss'
import Slider from 'rc-slider'
interface FundingSliderProps {
  sliderData: {
    id: number
    name: string
    type: 'securityClass' | 'scenario'
    isPresent: boolean
    currentValuations: number
  }[]
  setClassIds: (classIds: string[]) => void
  setScenarioIds: (scenarioIds: string[]) => void
  classIds: string[]
  scenarioIds: string[]
}

const FundingSlider: React.FC<FundingSliderProps> = ({
  sliderData,
  setClassIds,
  classIds,
  setScenarioIds,
  scenarioIds,
}: FundingSliderProps) => {

  const marks = sliderData.map((item: any, index: number) => ({
    value: index,
    label: (
      <div>
        <strong>{item.name}</strong>
        <br />
        <span style={{ color: item.isPresent ? '#28a745' : '#b0b0b0' }}>
          {item.isPresent ? 'Present' : item.type === 'securityClass' ? 'Share Class' : 'Scenario'}
        </span>
      </div>
    ),
    style: { color: item.isPresent ? '#28a745' : '#b0b0b0' },
  }))

  const handleChange = (value: number | number[]) => {
    const selectedItems = sliderData.slice(0, (value as number) + 1)
    const selectedClassIds = selectedItems
      .filter((item: any) => item.type === 'securityClass')
      .map((item: any) => item.id)
    const selectedScenarioIds = selectedItems
      .filter((item: any) => item.type === 'scenario')
      .map((item: any) => item.id)

    setClassIds(selectedClassIds)
    setScenarioIds(selectedScenarioIds)
  }

  const marksObject = marks.reduce<
    Record<number, { label: JSX.Element; style?: React.CSSProperties }>
  >((acc, { value, label, style }) => {
    acc[value] = { label, style }
    return acc
  }, {})

  console.log(marksObject, ' marksObject')
  console.log(sliderData, ' sliderData')

  return (
    <>
      <div className='bg-white rounded w-100 py-8 px-8 mb-4'>
        <div className='py-8 px-8'>
          <Slider
            min={0}
            max={sliderData.length - 1}
            step={1}
            defaultValue={classIds.length - 1}
            marks={marksObject}
            dotStyle={{
              height: 20,
              width: 20,
              top: -7,
              background: 'bg-primary',
            }}
            activeDotStyle={{ borderColor: '#007bff' }}
            trackStyle={{ backgroundColor: 'bg-primary', height: 7 }}
            railStyle={{ height: 7 }}
            handleStyle={{
              height: 20,
              width: 20,
              marginTop: -7,
              borderColor: '#007bff',
              backgroundColor: '#007bff',
            }}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )
}

export default FundingSlider
